function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M11.61,30.3v30.9c0,2,1.7,3.7,3.7,3.7h47c2,0,3.7-1.7,3.7-3.7v-30.9c0-2-1.7-3.7-3.7-3.7H15.31c-2,0-3.7,1.6-3.7,3.7M63.51,30.3v30.9c0,.7-.6,1.2-1.2,1.2H15.31c-.7,0-1.2-.6-1.2-1.2v-30.9c0-.7.6-1.2,1.2-1.2h47c.7,0,1.2.5,1.2,1.2"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M5.41,41.4v8.7c0,2,1.7,3.7,3.7,3.7v-2.5c-.7,0-1.2-.6-1.2-1.2v-8.7c0-.7.6-1.2,1.2-1.2v-2.5c-2,0-3.7,1.7-3.7,3.7"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M17.71,40.6v2.4h4.8c-1.8,2.3-2.1,3.8-2.1,7.9h2.5c0-4.5.2-5,3.3-8.3l-.9-2.1h-7.6v.1Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M35.11,40.6v2.4h4.8c-1.8,2.3-2.1,3.8-2.2,7.9h2.5c0-4.5.2-5,3.3-8.3l-.9-2.1h-7.5v.1Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M52.41,40.6v2.4h4.8c-1.8,2.3-2.1,3.8-2.2,7.9h2.5c0-4.5.2-5,3.3-8.3l-.9-2.1h-7.5v.1Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M28.91,30.3h2.5v30.9h-2.5v-30.9Z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M46.21,30.3h2.5v30.9h-2.5v-30.9Z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M69.71,15.1c-2.7,0-4.8,2.2-4.8,4.8,0,2.2,1.5,4.1,3.6,4.7v15.6c.7,0,1.2.6,1.2,1.2v8.6c0,.7-.6,1.2-1.2,1.2v2.5c2,0,3.7-1.7,3.7-3.7v-8.7c0-1.1-.4-2.1-1.2-2.8v-13.9c2.6-.7,4.1-3.3,3.4-5.9-.6-2.1-2.5-3.6-4.7-3.6M69.71,22.3c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4,2.4,1.1,2.4,2.4h0c0,1.3-1.1,2.4-2.4,2.4"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

export default __webpack_public_path__ + "static/media/Slots-inactive.11b13904.svg";
export { SvgComponent as ReactComponent };